module.exports = __webpack_public_path__ + "static/Untitled-1-19-6e4974867fa5298a67e602a7a52f9109.jpg";